import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { Organization } from "@/types/organizations";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useOrganization = (organizationId: number) => {
  const userToken = useAuth()?.userToken ?? "";
  const url = new URL(`${ENDPOINTS.organizations}/${organizationId}`);
  return useQuery(
    [ENDPOINTS.organizations, organizationId],
    (): Promise<Organization> =>
      fetch(url, {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
    {
      enabled: !!organizationId,
      staleTime: 1000 * 30, // 30 seconds - prevents unnecessary background refetches
    },
  );
};
